import { Action } from "redux";

export enum HomeActionType {
    HOME_PAGE_INIT = "HOME_PAGE_INIT",
}

export interface IInitHomeAction extends Action {
    type: HomeActionType.HOME_PAGE_INIT;
}

export const initHomeAction = () => ({
    type: HomeActionType.HOME_PAGE_INIT,
});

export type IHomeAction = IInitHomeAction;
